declare namespace $ {

	type $mol_view__sub_shm_hitalama_components_menu_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__hint_shm_hitalama_components_menu_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__arg_shm_hitalama_components_menu_3 = $mol_type_enforce<
		({ 
			'component': any,
			'application_tab': any,
			'application_version': any,
			'application_run': any,
			'application_draft': any,
			'application_draft_edit': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_components_menu_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_text__text_shm_hitalama_components_menu_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_menu['version_label'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_shm_hitalama_components_menu_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_menu['links'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__arg_shm_hitalama_components_menu_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_menu['link_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_hitalama_components_menu_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_menu['link_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__sub_shm_hitalama_components_menu_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_menu['link_content'] >
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_hitalama_components_menu_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_components_menu extends $mol_page {
		Name( ): $mol_view
		Close_icon( ): $mol_icon_close
		Close( ): $mol_link
		version_label( ): string
		Version( ): $mol_text
		links( ): readonly(any)[]
		Links( ): $mol_list
		link_arg( id: any): Record<string, any>
		link_current( id: any): boolean
		link_content( id: any): readonly($mol_view_content)[]
		drafts_count( ): string
		definition( ): $shm_hitalama_map_widget_entity_custom
		versions( ): $shm_hitalama_components_versions
		drafts( ): $shm_hitalama_components_drafts_model
		tab( ): string
		minimal_width( ): number
		title_content( ): readonly(any)[]
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		Link( id: any): $mol_link
		Drafts_count( ): $mol_view
	}
	
}

//# sourceMappingURL=menu.view.tree.d.ts.map